import { max, min } from 'date-fns'
import { isEmpty } from 'lodash'
import { createSelector } from 'reselect'
import { IDateRange } from '../../../utils/Date'
import { IStore } from '../../index'

export function getFromDate(state: IStore) {
  return state.bookingCalendar.dates.rendered.from
}

export function getToDate(state: IStore) {
  return state.bookingCalendar.dates.rendered.to
}

export function getManualDate(state: IStore) {
  return state.bookingCalendar.dates.manual
}

export function getLoadedDates(state: IStore) {
  return state.events.loadedDates.sort((a, b) => +a.from - +b.from)
}

export function isSomeLoaded(state: IStore) {
  return state.events.fullyLoaded || !isEmpty(state.events.loadedDates)
}

export function getIsFullyLoaded(state: IStore) {
  return state.events.fullyLoaded
}

export function getScrollableFromDate(state: IStore) {
  return state.bookingCalendar.dates.scrollable.from
}

export function getScrollableToDate(state: IStore) {
  return state.bookingCalendar.dates.scrollable.to
}

export const getUnloadedScrollableDates = createSelector(
  [
    getLoadedDates,
    getIsFullyLoaded,
    getScrollableFromDate,
    getScrollableToDate,
  ],
  (loadedDates, fullyLoaded, from, to) => {
    if (fullyLoaded) return []
    if (!loadedDates.length) {
      return [
        {
          from,
          to,
        },
      ]
    }

    const ranges = []
    let current = from
    let i = 0
    while (current < to) {
      if (loadedDates[i]) {
        if (loadedDates[i].from > current) {
          ranges.push({
            from: current,
            to: loadedDates[i].from,
          })
        }
        current = loadedDates[i].to
        i++
      } else {
        current = to
      }
    }

    return ranges
  },
)

export const getUnloadedForRange = createSelector(
  [getLoadedDates],
  loadedDates => (dates: IDateRange): IDateRange | null => {
    if (!loadedDates.length) {
      return null
    }

    const potentialStart = loadedDates.find(
      v => v.from <= dates.from && v.to >= dates.from,
    )
    const potentialEnd = loadedDates.find(
      v => v.from <= dates.to && v.to >= dates.to,
    )

    return {
      from: potentialStart ? max(potentialStart.to, dates.from) : dates.from,
      to: potentialEnd ? min(potentialEnd.from, dates.to) : dates.to,
    }
  },
)
